import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL } from '@utils/api/endpoints';

export type AiSummaryJobRecord = {
  job_id: string;
  status: string;
  created_at: string | null;
  date_completed: string | null;
  pipeline_version: string | null;
  model_version: string | null;
  output_language: string | null;
  created_by_id: number | null;
};

export type OrgAiSummaryJobsResponse = {
  organization_id: number;
  total_results: number;
  count: number;
  result: AiSummaryJobRecord[];
};

export const useGetOrgAiSummaryJobs = (orgId: number | string) => {
  return useQuery<OrgAiSummaryJobsResponse>(
    ['sysopOrgAiSummaryJobs', orgId],
    async () => {
      const { data } = await Axios.get(
        GET_URL(String(orgId)).sysopOrgAiSummaryJobs
      );
      return data;
    },
    { enabled: !!orgId, staleTime: 30_000 }
  );
};
